import { render, staticRenderFns } from "./add_unidade.vue?vue&type=template&id=f8f35248&scoped=true&"
import script from "./add_unidade.vue?vue&type=script&lang=js&"
export * from "./add_unidade.vue?vue&type=script&lang=js&"
import style0 from "./add_unidade.vue?vue&type=style&index=0&id=f8f35248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f35248",
  null
  
)

export default component.exports